{
  "tabs": {
    "chat": "Talanoaga",
    "reminders": "Manatua",
    "calendar": "Kalena",
    "settings": "Seti"
  },
  "common": {
    "cancel": "Faʻaleaogaina",
    "save": "Sefe",
    "confirm": "Faamaonia",
    "delete": "Tape",
    "back": "Toe",
    "close": "Tapuni",
    "edit": "Faasaʻo",
    "search": "Saili",
    "all": "Uma",
    "loading": "O lo'o utaina...",
    "error": "Ua iai se mea sese",
    "notFound": "Le maua",
    "tryAgain": "Fa'amolemole taumafai toe",
    "retry": "Toe taumafai",
    "undo": "Toe fa'aleleia",
    "pullToRefresh": "Toso e toe faʻafou",
    "justNow": "na'o le taimi nei"
  },
  "auth": {
    "welcome": "Afio mai i FishMemory",
    "tagline": "O lau fesoasoani manatua WhatsApp, o lo'o i lou ato.",
    "subtitle": "O lau fesoasoani manatua WhatsApp, o lo'o i lou ato.",
    "phoneLabel": "Lou numera WhatsApp",
    "phoneHint": "O le a matou lafoina se code faʻamaonia i WhatsApp",
    "invalidPhone": "Fa'amolemole ulufale i se numera telefoni sa'o",
    "continue": "Fa'aauau",
    "enterPhone": "Ulufale i lau numera WhatsApp",
    "phonePlaceholder": "Numera telefoni",
    "sendCode": "Lafo Code",
    "verifyTitle": "Faamaonia lau numera",
    "otpSentTo": "Ua lafoina se code 6-numera i {{phone}} i WhatsApp",
    "enterFullCode": "Fa'amolemole ulufale uma 6-numera",
    "invalidOtp": "Code sese. Fa'amolemole taumafai toe.",
    "otpFailed": "Le mafai ona lafo code. Toe taumafai.",
    "otpResent": "Ua toe lafoina le code",
    "resendIn": "Toe lafo i totonu o le {{seconds}}s",
    "resendCode": "Toe lafo code",
    "enterOtp": "Ulufale i le code na lafo i lau WhatsApp",
    "verify": "Faamaonia",
    "resend": "Toe lafo code",
    "wrongNumber": "Numera sese?",
    "backToPhone": "Toe i numera telefoni",
    "editPhone": "Faasaʻo numera telefoni",
    "error": "Sese",
    "setupTitle": "Se'i tatou fa'atulaga",
    "setupSubtitle": "E mafai ona e suia i taimi uma i Seti",
    "namePlaceholder": "Lou igoa",
    "letsGo": "Fa'ai'u fa'atulagaga",
    "skipForNow": "Soso'o mo le taimi nei"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Taina se fe'au...",
    "inputPlaceholder": "Taina se fe'au...",
    "typing": "O lo'o taina e FishMemory...",
    "online": "I luga ole laiga",
    "connecting": "O lo'o feso'ota'i...",
    "reconnecting": "Toe feso'ota'i...",
    "offline": "Le i luga ole laiga",
    "empty": "Amata se talanoaga",
    "emptyHint": "Fausia manatua, siaki lau polokalame, pe fesili mo fesoasoani.",
    "emptyAction": "Lafo se manatua faʻataʻitaʻi",
    "actions": "Gaioiga talanoaga",
    "keep": "Taofi fe'au",
    "clearTitle": "Fa'amama talanoaga",
    "clearConfirm": "E te mautinoa e tape uma fe'au i lenei masini? E le mafai ona toe fa'afo'i.",
    "clear": "Fa'amama talanoaga",
    "optionSelected": "Filifilia: {{label}}",
    "sendingSelection": "O lo'o lafoina...",
    "connectionLost": "Toe feso'ota'i..."
  },
  "reminders": {
    "title": "O A'u Manatua",
    "active": "Galuega",
    "today": "Aso Nei",
    "thisWeek": "O le Vaiaso",
    "history": "Tala'aga",
    "items": "mea",
    "emptyTitle": "Leai ni manatua i le taimi nei",
    "emptySubtitle": "Fausia se tasi mai le talanoaga ma o le a aliali mai iinei.",
    "emptyAction": "Tatala talanoaga",
    "filterActive": "Galuega",
    "filterToday": "Aso Nei",
    "filterWeek": "O le Vaiaso",
    "filterHistory": "Tala'aga",
    "emptyState": "Leai ni manatua i le taimi nei. Amata talanoaina!",
    "swipeDone": "Fa'ai'u",
    "swipeSnooze": "Fa'amalūlū",
    "swipeDelete": "Tape",
    "search": "Saili manatua...",
    "upcoming": "O lo'o lumanai",
    "completed": "Ua mae'a",
    "overdue": "Ua tuai",
    "tomorrow": "A taeao",
    "synced": "Fa'atasi {{value}}",
    "swipeHint": "Swipe i se manatua mo nisi gaioiga",
    "noResults": "Leai ni manatua e fetaui ma lau sailiga",
    "noResultsHint": "Taumafai i se isi upu autu po'o le fa'amama o le sailiga",
    "deleteAllFailed": "Le mafai ona tape uma manatua"
  },
  "calendar": {
    "title": "Kalena",
    "today": "Aso Nei",
    "tomorrow": "A taeao",
    "completed": "ua mae'a",
    "noEvents": "Leai ni mea na fa'atulaga",
    "noEventsSubtitle": "Filifili se aso e va'ai ai i manatua ma mea o le kalena.",
    "googleEvent": "Kalena Google",
    "legendActive": "Galuega",
    "legendRecurring": "Toe fai",
    "legendDone": "Ua mae'a",
    "legendGoogle": "Google",
    "previousMonth": "Masina ua te'a",
    "nextMonth": "Masina fou",
    "previousYear": "Tausaga ua te'a",
    "nextYear": "Tausaga fou",
    "goToToday": "Alu i le aso nei",
    "all": "Uma",
    "active": "Galuega",
    "done": "Ua mae'a",
    "paused": "Taofia"
  },
  "settings": {
    "title": "Seti",
    "profile": "Talaaga",
    "name": "Igoa Fa'aalia",
    "enterName": "Ulufale lau igoa",
    "language": "Gagana",
    "uiLanguage": "Gagana o le app",
    "uiLanguageHelp": "Suia le UI o le app, igoa o kalena, ma le fa'atonuga o le fa'atulagaga i lenei masini na'o.",
    "serverLanguage": "Gagana talanoaga",
    "serverLanguageHelp": "Suia le gagana o tali a le server ma fe'au manatua mo lau teugatupe.",
    "timezone": "Ituaiga taimi",
    "currentTimezone": "Ituaiga taimi o lo'o iai nei",
    "timezoneHelp": "O taimi uma o manatua o lo'o faʻaalia i lenei ituaiga taimi.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Sefe ituaiga taimi",
    "timezoneSaved": "Ua fa'afou le ituaiga taimi",
    "detect": "Su'e",
    "detectFailed": "Le mafai ona su'e le ituaiga taimi",
    "autoDetect": "Su'e otometi mai GPS",
    "notifications": "Fa'asilasilaga",
    "notificationsHelp": "O manatua toe fa'asilasila e pulea ai fa'asilasilaga toe fai pe a uma ona lafo se manatua. O le pulega o fa'atagaga fa'asilasilaga i le masini o lo'o i totonu o seti o lau telefoni.",
    "pushEnabled": "Fa'asilasilaga Push",
    "autoDoneOnFire": "Fa'amaonia otometi pe a fa'agaoioia",
    "autoDoneOnFireDesc": "A leai, o manatua o le a tumau pea se'i vagana ua e fa'amaonia ua mae'a.",
    "googleCalendar": "Kalena Google",
    "google": "Kalena Google",
    "googleConnected": "Ua feso'ota'i",
    "googleDisconnected": "Le feso'ota'i",
    "googleConnectedHelp": "O manatua fou e mafai ona fa'atasi i lau kalena otometi.",
    "googleDisconnectedHelp": "Feso'ota'i Kalena Google e tausia manatua ma mea fa'atulaga i le laina.",
    "googleConnectFailed": "Le mafai ona feso'ota'i Kalena Google",
    "connected": "Ua feso'ota'i",
    "disconnected": "Le feso'ota'i",
    "connect": "Feso'ota'i",
    "disconnect": "Taofi feso'ota'i",
    "autoSync": "Otometi fa'atasi manatua fou",
    "autosync": "Otometi fa'atasi manatua fou",
    "subscription": "Lesitala",
    "trialUsed": "Su'ega: {{used}}/{{total}} fa'aoga",
    "trialStatus": "Su'ega avanoa",
    "activeStatus": "Lesitala malosi",
    "expiredStatus": "Ua uma le lesitala",
    "unsubscribedStatus": "Le lesitala",
    "about": "E uiga",
    "version": "Fa'amaumauga",
    "logout": "Saini ese",
    "logoutTitle": "Saini ese",
    "logoutConfirm": "E te mautinoa e te fia saini ese?",
    "noName": "Leai se igoa ua seti",
    "serverConnection": "Feso'ota'iga server",
    "serverUrl": "URL server",
    "serverEdit": "Faasaʻo",
    "saveReconnect": "Sefe ma toe feso'ota'i",
    "resetDefault": "Toe seti i le masani",
    "invalidServerUrlTitle": "URL server sese",
    "invalidServerUrlMessage": "Ulufale i se URL server http po'o https sa'o, fa'ata'ita'iga https://example.com",
    "uiLanguageChangeFailed": "Le mafai ona suia le gagana o le app. Fa'amolemole taumafai toe.",
    "serverLanguageChangeFailed": "Le mafai ona suia le gagana talanoaga. Fa'amolemole taumafai toe.",
    "timezoneChangeFailed": "Le mafai ona suia le ituaiga taimi. Fa'amolemole taumafai toe.",
    "autoSyncChangeFailed": "Le mafai ona fa'afou otometi fa'atasi. Fa'amolemole taumafai toe.",
    "nameChangeFailed": "Le mafai ona fa'afou le igoa fa'aalia. Fa'amolemole taumafai toe.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Auiliiliga manatua",
    "editTime": "Faasaʻo Taimi",
    "rename": "Suia Igoa",
    "snooze": "Fa'amalūlū",
    "snooze15": "Fa'amalūlū mo le 15 minute",
    "pause": "Taofia",
    "pauseReminder": "Taofia manatua",
    "resume": "Fa'aauau",
    "resumeReminder": "Fa'aauau manatua",
    "skip": "Soso'o i le isi",
    "skipOccurrence": "Soso'o lenei taimi",
    "syncGoogle": "Fa'atasi i Google",
    "delete": "Tape",
    "deleteTitle": "Tape Manatua",
    "deleteConfirm": "O lenei manatua o le a tape atoa.",
    "deleteRecurringTitle": "Tape Manatua Toe fai",
    "deleteRecurringMessage": "E te manaʻo e soso'o lenei taimi po'o le tape atoa o le fa'asologa?",
    "deleteThisOccurrence": "Soso'o lenei taimi",
    "deleteEntireSeries": "Tape le fa'asologa atoa",
    "done": "Ua mae'a",
    "markDone": "Fa'amaonia ua mae'a",
    "undo": "Toe fa'aleleia",
    "undoPrompt": "Mana'omia e toe fa'aola? Toe fa'aleleia nei.",
    "recurring": "Toe fai",
    "nextRun": "Sosoo ai",
    "oneTime": "Tasi taimi",
    "pending": "Fa'atali",
    "sent": "Ua lafo",
    "paused": "Taofia",
    "active": "Galuega",
    "snoozed": "Fa'amalūlū",
    "localTime": "Fa'aalia i lau taimi lotoifale",
    "recurrence": "Toe fai",
    "created": "Fausia",
    "tags": "Tag",
    "fireCount": "Aso fa'agaoioia",
    "actions": "Gaioiga",
    "none": "Leai",
    "snoozeFailed": "Le mafai ona fa'amalūlū manatua",
    "pauseFailed": "Le mafai ona taofia manatua",
    "resumeFailed": "Le mafai ona fa'aauau manatua",
    "skipFailed": "Le mafai ona soso'o manatua",
    "doneFailed": "Le mafai ona fa'amaonia manatua ua mae'a",
    "undoFailed": "Le mafai ona toe fa'aleleia tulaga manatua",
    "deleteFailed": "Le mafai ona tape manatua",
    "rescheduleTitle": "Toe fa'atulagaina?",
    "rescheduleMsg": "O lenei manatua ua tuai. E te manaʻo e toe fa'atulagaina?",
    "reschedule15": "I totonu o le 15 minute",
    "reschedule60": "I totonu o le 1 itula",
    "keepOverdue": "Taofi i le tulaga o lo'o iai"
  },
  "onboarding": {
    "slide1Title": "Afio mai i FishMemory",
    "slide1Sub": "O lau fesoasoani manatua patino — fa'aaogaina e WhatsApp ma faia mo lou ato.",
    "slide2Title": "Na'o le Talanoa Fa'alenatura",
    "slide2Sub": "Taina manatua i lau auala mafaufau: \"Manatua ia vala'au mai i le tina i le taeao i le 3pm\" — matou te faia le isi.",
    "slide3Title": "Aua ne'i misia se mea",
    "slide3Sub": "Maua fa'asilasilaga i le taimi, fa'atulaga ma tag, ma nofo i luga o mea uma tāua.",
    "getStarted": "Amata",
    "next": "Sosoo",
    "firstReminderTitle": "Fausia lau manatua muamua!",
    "firstReminderHint": "Taumafai e taina se mea e pei o:",
    "firstReminderExample": "Manatua ia inu vai i le taeao i le 9 AM",
    "gotIt": "Maua!",
    "notifRationaleTitle": "Nofo i le taimi",
    "notifRationaleBody": "E mana'omia e FishMemory fa'asilasilaga e manatua ai oe i le taimi. O le a na'o fa'asilasilaga mo manatua na e faia.",
    "notifRationaleAllow": "Fa'aaoga Fa'asilasilaga",
    "notifRationaleLater": "Masalo i le isi taimi",
    "swipeHint": "Swipe i le taumatau mo gaioiga vave →",
    "calendarDragHint": "Toso e fa'alautele ↕"
  }
}
